export default function myImageLoader({ src, width, quality }) {
    return `/api/external/image?name=${src}&size=${width}x${width}&q=${quality || 75}`
}